export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                BASIC: 'BASIC',
                SECONDARY: 'SECONDARY',
                SECONDARY_SPECIAL: 'SECONDARY_SPECIAL',
                PROFESSIONAL_HIGHER: 'PROFESSIONAL_HIGHER',
                ACADEMIC_HIGHER: 'ACADEMIC_HIGHER',
                MASTER: 'MASTER',
                DOCTOR: 'DOCTOR'
            },
            LABELS: {
                BASIC: $translate.instant('performanceReview.education.Basic education'),
                SECONDARY: $translate.instant('performanceReview.education.Secondary education'),
                SECONDARY_SPECIAL: $translate.instant('performanceReview.education.Secondary specialized education'),
                PROFESSIONAL_HIGHER: $translate.instant('performanceReview.education.Professional higher education'),
                ACADEMIC_HIGHER: $translate.instant('performanceReview.education.Academic higher education'),
                MASTER: $translate.instant('performanceReview.education.Master\'s degree'),
                DOCTOR: $translate.instant('performanceReview.education.Doctoral degree')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });

    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/review/education/index.js